import React from 'react';
import { SVGProps } from './type';

export const IconBridgingReport = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M13.5833 20.6667H7.33333C5.49238 20.6667 4 19.1743 4 17.3333V7.33333C4 5.49238 5.49238 4 7.33333 4H12.6785L17.3333 8.65482V12.3333C18.2538 12.3333 19 13.0795 19 14V15.6667C19 15.9702 18.9188 16.2549 18.777 16.5C18.9188 16.7451 19 17.0298 19 17.3333V19C19 19.9205 18.2538 20.6667 17.3333 20.6667H13.5833ZM14.8333 19H17.3333V17.3333H12.3333V19H14.8333ZM10.6667 19V17.3333C10.6667 17.0298 10.7478 16.7451 10.8896 16.5C10.7478 16.2549 10.6667 15.9702 10.6667 15.6667V14C10.6667 13.0795 11.4129 12.3333 12.3333 12.3333H15.6667V10.6667H13.1667C11.786 10.6667 10.6667 9.54738 10.6667 8.16667V5.66667H7.33333C6.41286 5.66667 5.66667 6.41286 5.66667 7.33333V17.3333C5.66667 18.2538 6.41286 19 7.33333 19H10.6667ZM17.3333 15.6667V14H12.3333V15.6667H17.3333ZM12.3333 6.01184V8.16667C12.3333 8.6269 12.7064 9 13.1667 9H15.3215L12.3333 6.01184Z"
      fill={fill}
    />
  </g>
);
